import { BackendModel, BackendService } from "../core/backend.service";
import { ImagenBanner } from "./banner-imagen-upload/imagen-banner.model";

export class Banner extends BackendModel {

    static path = '/banner/';
    nombre: string;
    fechaDesde: Date;
    fechaHasta: Date;
    activo: boolean;
    imagen: ImagenBanner;
    clienteId: number;
    constructor(protected backendService: BackendService, model?: Banner) {
        super(backendService, model);
    }
}



// WEBPACK FOOTER //
// ./src/app/banner/banner.model.ts